var map = {
	"./1.jpg": 2169,
	"./10.jpg": 2170,
	"./2.jpg": 2171,
	"./3.jpg": 2172,
	"./4.jpg": 2173,
	"./5.jpg": 2174,
	"./6.jpg": 2175,
	"./7.jpg": 2176,
	"./8.jpg": 2177,
	"./9.jpg": 2178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2168;